import { render, staticRenderFns } from "./addMessageTemple.vue?vue&type=template&id=5da9f7f8&scoped=true&"
import script from "./addMessageTemple.vue?vue&type=script&lang=js&"
export * from "./addMessageTemple.vue?vue&type=script&lang=js&"
import style0 from "./addMessageTemple.vue?vue&type=style&index=0&id=5da9f7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9f7f8",
  null
  
)

export default component.exports